import DashboardRoute from "./dashboard/Dashboard.Route";
import MasterRoute from './master/MasterRoute';
import SettingsRoute from './settings/SettingsRoute';
import UsersRoute from './users/UsersRoute';
import NotificationsRoute from './notifications/NotificationsRoute';
import ProductManagementRoute from './product_management/ProductManagementRoute';
import InventoryRoute from './inventory/InventoryRoute';
import SalesRoute from './sales/SalesRoute';

const PrivateRoute = () => {
    return [
        ...DashboardRoute(),
        ...MasterRoute(),
        ...SettingsRoute(),
        ...UsersRoute(),
        ...NotificationsRoute(),
        ...ProductManagementRoute(),
        ...InventoryRoute(),
        ...SalesRoute(),
    ]
}

export default PrivateRoute;